import { render, staticRenderFns } from "./DoriSummaryView.vue?vue&type=template&id=05341c2a&scoped=true&"
import script from "./DoriSummaryView.vue?vue&type=script&lang=ts&"
export * from "./DoriSummaryView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05341c2a",
  null
  
)

export default component.exports